// KAN-1028 — a bulk run's id is minted IN MEMORY, once per run, and held by the
// run for its whole life (so Retry inside the same run reuses its keys). It is
// never persisted: a reload or a later run gets a fresh id, so an old
// `bulk:<runId>:<invoice>` key can never make a new send/reminder look
// "already sent". After a reload the server dedupes on its own (require_draft
// -> ALREADY_SENT, and the reminder cooldown).

const LEGACY_KEYS = ['cv_bulk_send_run_id', 'cv_bulk_create_run_id'];

export function mintBulkRunId() {
  return (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function')
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

/** Remove run ids older builds left in sessionStorage. Best effort. */
export function purgeLegacyBulkRunIds() {
  try {
    LEGACY_KEYS.forEach((k) => window.sessionStorage.removeItem(k));
  } catch { /* storage unavailable */ }
}
